<data-table>
  <data-row columns="6">
    <custom-input [label]="'contact.first-name' | translate"
      [placeholder]="'contact.first-name-placeholder' | translate"
      [(value)]="contact.firstName"
      [required]="isPrimaryContact">
    </custom-input>
  </data-row>
  <data-row columns="6">
    <custom-input [label]="'contact.last-name' | translate"
      [placeholder]="'contact.last-name-placeholder' | translate"
      [(value)]="contact.lastName">
    </custom-input>
  </data-row>
  @for (contactPhone of contact.contactPhones; track contactPhone; let phoneIndex = $index) {
  <ng-container>
      <data-row columns="8">
          <custom-input [label]="(contactPhone.mobile ? 'contact.mobile' : 'contact.phone') | translate: { index: phoneIndex+1 }"
                        [placeholder]="(contactPhone.mobile ? 'contact.mobile-placeholder' : 'contact.phone-placeholder') | translate"
                        [(value)]="contactPhone.number"
                        (valueChange)="setMobile(contactPhone);"
                        [validation]="validationTypeEnum.Phone"
                        [required]="phoneIndex == 0 && isPrimaryContact">
          </custom-input>
      </data-row>
      <data-row columns="4">
          <custom-input [label]="'contact.is-mobile' | translate"
                        [(value)]="contactPhone.mobile"
                        [inputType]="inputTypeEnum.Switch">
          </custom-input>
      </data-row>
  </ng-container>
  }
  <data-row>
    <custom-input [label]="'general.email' | translate "
      [placeholder]="'general.email-placeholder' | translate"
      [(value)]="contact.emailAddress"
      [validation]="validationTypeEnum.Email"
      [required]="isPrimaryContact">
    </custom-input>
  </data-row>
  <data-row columns="6">
    <custom-input [label]="'contact.role' | translate"
      [placeholder]="'contact.role-placeholder' | translate"
      [(value)]="contact.role">
    </custom-input>
  </data-row>
  <data-row columns="6">
    @if (isPrimaryContact) {
      <div><mat-label>{{ 'contact.set-as-primary' | translate }}</mat-label></div>
    }
    @if (isBillingContact) {
      <div><mat-label>{{ 'contact.is-billing-contact' | translate }}</mat-label></div>
    }
    @if (!wasPrimaryAtStart) {
      <custom-input
        [label]="'contact.primary' | translate"
        [inputType]="inputTypeEnum.Switch"
        [(value)]="isPrimaryContact"
        (click)="!isPrimaryContact || $event.preventDefault()">
      </custom-input>
    }
  </data-row>
</data-table>
